import Menu from "../components/Menu";
import { motion, AnimatePresence } from "framer-motion";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Helmet } from "react-helmet";

export default function Offer() {
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.0, ease: "easeOut" },
    },
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Usługi fotografii i wideo nieruchomości",
            provider: {
              "@type": "ProfessionalService",
              name: "Tomasz Fotograf",
              url: "https://tomaszfotograf.pl/fotografia-wnetrz-i-nieruchomosci",
            },
            areaServed: {
              "@type": "AdministrativeArea",
              name: "Warszawa i okolice",
            },
            description:
              "Kompleksowe usługi wizualne dla rynku nieruchomości, marketingu wnętrz oraz branży HoReCa.",
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: "Oferta usług",
              itemListElement: [
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Fotografia wnętrz i architektury",
                    description:
                      "Zdjęcia mieszkań i domów na sprzedaż lub wynajem (ogłoszenia, Airbnb, Booking), sesje wnętrz dla architektów i projektantów, fotografia hoteli, restauracji, showroomów i biur. Pełna obróbka i retusz premium, realizacja do 24 godzin.",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Filmy z nieruchomości",
                    description:
                      "Filmowe ujęcia wnętrz i architektury. Format poziomy (YouTube, strony WWW, prezentacje inwestycyjne) oraz pionowy (Instagram, TikTok, Facebook Ads). Dynamiczny montaż inspirowany produkcjami reklamowymi.",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Zdjęcia i filmy z drona",
                    description:
                      "Ujęcia z powietrza prezentujące lokalizację, działkę i otoczenie. Podkreślenie skali i kontekstu inwestycji. Loty realizowane zgodnie z obowiązującymi przepisami i ubezpieczeniem.",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Home staging i przygotowanie nieruchomości",
                    description:
                      "Staging podstawowy, staging premium (scenografia filmowa, współpraca z dekoratorami) oraz staging wirtualny - fotorealistyczne wizualizacje pustych wnętrz.",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Galeria premium online",
                    description:
                      "Galeria zdjęć w pełnej jakości na serwerze fotografa, gotowa do udostępniania w ogłoszeniach, SMS, WhatsApp i mediach społecznościowych.",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Warunki współpracy",
                    description:
                      "Dojazd do 30 km od Warszawy w cenie. Powyżej 30 km - 1 zł za kilometr. Przy stałej współpracy ceny ustalane indywidualnie.",
                  },
                },
              ],
            },
          })}
        </script>
        <title>Fotografia Wnętrz i Nieruchomości | Tomasz Fotograf</title>
        <meta
          name="description"
          content="Profesjonalna fotografia wnętrz, nieruchomości, apartamentów, domów i hoteli. Zdjęcia, które zwiększają zainteresowanie ofertą."
        />
      </Helmet>
      <Menu />
      <section className="section section-dark section-offer" key="sectiongray">
        <AnimatePresence>
          <motion.div
            className="h1a"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row key="row1">
              <Col sm={12} md={4}>
                OFERTA USŁUG
              </Col>
              <Col sm={12} md={8}>
                <p className="h4a">
                  Oferuję kompleksowe usługi wizualne dla rynku nieruchomości,
                  marketingu wnętrz oraz branży HoReCa.
                </p>
                <hr />
                <p className="h4a">1. Fotografia wnętrz i architektury</p>
                <p className="h4a">
                  ✔ zdjęcia mieszkań i domów na sprzedaż lub wynajem
                  (ogłoszenia, Airbnb, Booking)
                  <br />✔ sesje wnętrz dla architektów i projektantów <br />✔
                  fotografia hoteli, pensjonatów i restauracji <br />✔ zdjęcia
                  showroomów, biur i przestrzeni komercyjnych <br />✔ pełna
                  obróbka i retusz w standardzie premium <br />✔ dostarczenie
                  materiałów do 24 godzin
                </p>
                <hr />
                <p className="h4a">
                  2. Filmy z nieruchomości (format poziomy i pionowy)
                </p>
                <p className="h4a">
                  ✔ filmowe ujęcia wnętrz i architektury <br />✔ format poziomy
                  (YouTube, strony WWW, prezentacje inwestycyjne) <br />✔ format
                  pionowy (Instagram, TikTok, Facebook Ads) <br />✔ dynamiczny
                  montaż inspirowany produkcjami reklamowymi
                </p>
                <hr />
                <p className="h4a">3. Dron - zdjęcia i filmy z powietrza</p>
                <p className="h4a">
                  ✔ prezentacja lokalizacji, działki i otoczenia
                  <br />
                  ✔ ujęcia podkreślające skalę i kontekst inwestycji
                  <br />✔ loty zgodne z obowiązującymi przepisami i
                  ubezpieczeniem
                  <br />✔ idealne rozwiązanie dla deweloperów, hoteli i obiektów
                  komercyjnych
                </p>
                <hr />

                <p className="h4a">
                  4. Staging - przygotowanie nieruchomości do zdjęć
                </p>
                <p className="h4a">
                  ✔ Staging podstawowy - uporządkowanie i lekkie wystylizowanie
                  przestrzeni. <br />✔ Staging Premium - scenografia filmowa,
                  współpraca ze scenografami i dekoratorami, pełne przygotowanie
                  wnętrza i kreacja nastroju (wycena indywidualna). <br />✔
                  Staging wirtualny - fotorealistyczne wizualizacje pustych
                  pomieszczeń realizowane przez projektantów z jokuko.pl
                </p>
                <hr />
                <p className="h4a">5. Galeria premium na moim serwerze</p>
                <p className="h4a">
                  Każdy klient otrzymuje link do galerii w pełnej jakości,
                  gotowy do wklejenia w ogłoszeniach, wysyłki SMS, WhatsApp lub
                  do udostępniania w social mediach.
                </p>
                <hr />
                <p className="h4a">6. Warunki współpracy</p>
                <p className="h4a">
                  ✔ dojazd do 30 km od Warszawy - w cenie <br />✔ powyżej 30 km
                  - 1 zł za kilometr <br />✔ przy stałej współpracy — ceny
                  negocjowane indywidualnie
                </p>
                <hr />
              </Col>
            </Row>
          </motion.div>
        </AnimatePresence>
      </section>
    </>
  );
}
